import { authApi } from "@shared/api";

export const getNewAccessToken = async () => {
  const response = await authApi.postApiV1AuthRefresh(
    { requestSource: "WEB" },
    { withCredentials: true },
  );

  return response.data;
};
